import { CareplanFilter, CareplanStatusFilter, RoDashboardTabs } from 'op-enums';
import { BaseConfigInterface } from './types';
import { BOOLEAN_OPTIONS, BOOLEAN_TBC_OPTIONS } from '../TreatmentInfoPage/Interface';

const anz_conf: BaseConfigInterface = {
  showPreferredName: true,
  SpecialPhysicsConsultVisible: false,
  ErrorPopup: {
    Generic:
      "We encountered an error. Please refresh the page. If the issue persists, please contact support: <a href='mailto:support-anz@lumonus.com'>support-anz@lumonus.com</a>",
    Practitioner:
      "We encountered an error. Please refresh the page. If the issue persists, please contact support: <a href='mailto:support-anz@lumonus.com'>support-anz@lumonus.com</a>",
    Patient: 'We encountered an error. Please refresh the page. If the issue persists, please contact your clinic.',
  },
  ReferringPhysicians: {
    oncologist: 'Responsible Physician',
    generalPractitioner: 'Primary Physician (GP)',
    referringSurgeon: 'Referring Physician 1',
    referringSurgeon2: 'Referring Physician 2',
    referringSurgeon3: 'Referring Physician 3',
  },
  DefaultValue: {
    cied: '',
    patientStatus: 'outPatient',
    previousRadioTreatment: '',
    treatmentRORequired: '',
    tumourName: 'tumour ',
  },
  Clinex: {
    betaTesting: false,
  },
  Diagnosis: {
    defaultMStageTypeFilter: 'Pathological',
  },
  Intake: {
    disabled: false,
    isProstateDisabled: false,
    breastMandatoryFields: [],
    lungMandatoryFields: [],
    headNeckMandatoryFields: [],
    lymphomaMandatoryFields: [],
    breastFormVersion: 2,
    breastFormShowExercise: false,
  },
  PatientSummary: {
    isVisible: true,
    labsEnabled: true,
    RODocumentUpload: false,
    documentFilterField: 'description',
    hideInsuranceTab: true,
    summaryLabel: 'Patient Chart',
  },
  OutcomesPage: {
    isVisible: false,
    DateFormat: 'DD-MMM-YYYY',
    DateTimeFormat: 'DD MMM YYYY h:mma',
  },
  OTRPage: {
    isVisible: false,
    DateFormat: 'DD-MMM-YYYY',
    DateTimeFormat: 'DD MMM YYYY h:mma',
  },
  DisplayButton: {
    displaySimButton: true,
  },
  DisplayModal: {
    submission: false,
  },
  TreatmentInfoPage: {
    mandatoryFields: ['intent', 'treatingDepartment', 'readyForCareDate', 'cied', 'previousRadioTreatment'],
    ReadyForCareDate: true,
    AdditionalBookingInfo: true,
    MDT: false,
    AuthorizedICDTreatingDepartments: [],
    Hormones: false,
    Brachytherapy: false,
    ccip: false,
    TreatmentStartDate: false,
    ConsentStatus: true,
    PharmacyPrescription: true,
    PerformanceStatus: true,
  },
  SimulationPage: {
    SpacerGelWarning: false,
    imagingText: 'Add imaging request',
    imagingCountTitle: 'Imaging',
    disableExtentDefined: true,
    disablePositionSetup: true,
    immobilisationLabel: 'Immobilisation',
  },
  PrescriptionPage: {
    MicrodosimetryTld: false,
    WeeklyPhysicsCheck: false,
    BasicDoseCalculation: false,
  },
  SubmissionPage: {
    PlanAimSubmissionType: 'Plan Aim',
    PlanAimHidden: true,
  },
  VolumingPage: {
    UsePrioritizedOARs: true,
    TargetValueDoseSuffixEnabled: false,
  },
  RadiationDashboard: {
    dateTimeFormat: 'DD/MM/YYYY hh:mm A',
    active: RoDashboardTabs.APPOINTMENTS,
    careplanDashboard: {
      careplanStatusFilters: [
        { id: CareplanStatusFilter.DRAFT, name: CareplanStatusFilter.DRAFT, checked: true },
        { id: CareplanStatusFilter.SIMULATION, name: CareplanStatusFilter.SIMULATION, checked: true },
        { id: CareplanStatusFilter.PLAN_AIM, name: CareplanStatusFilter.PLAN_AIM, checked: true },
        { id: CareplanStatusFilter.PRESCRIPTION, name: CareplanStatusFilter.PRESCRIPTION, checked: true },
        { id: CareplanStatusFilter.CPOT, name: CareplanStatusFilter.CPOT, checked: true },
      ],
      careplanFilters: [{ id: CareplanFilter.UNSUBMITTED, name: CareplanFilter.UNSUBMITTED, checked: false }],
      isPatientSummaryLinkEnabled: true,
    },
    showFilters: false,
  },
  QuestionLabel: {
    CIED: 'Cardiac Implantable Electronic Device (CIED)',
    RoRequired: 'RO Required',
    GoldSeeds: 'Gold Seeds',
    phase: 'Phase',
  },
  QuestionOptions: {
    CIED: BOOLEAN_TBC_OPTIONS,
    previousRadioTreatment: BOOLEAN_OPTIONS,
  },
  QuestionValidationChildren: {
    CIED: ['ciedProtocolRequired', 'preTreatmentCiedCheckRequired'],
    Staging: {
      Primary: {
        RO: ['laterality', 'diagnosisDate'],
        MO: ['laterality'],
      },
      Metastasis: {
        RO: ['laterality', 'diagnosisDate'],
        MO: [],
      },
    },
  },
  ResetMutationVariableDefaults: {
    CIED: {
      ciedProtocolRequired: '',
      preTreatmentCiedCheckRequired: '',
      referralToGcCardiologist: '',
      otherCiedInstructions: '',
    },
    CiedProtocolRequired: {
      preTreatmentCiedCheckRequired: '',
      referralToGcCardiologist: '',
      otherCiedInstructions: '',
    },
  },
  GetMutationVariableDefaults: {
    CIED: {
      ciedProtocolRequired: 'yes',
      preTreatmentCiedCheckRequired: 'yes',
      referralToGcCardiologist: 'no',
      otherCiedInstructions: '',
    },
    CiedProtocolRequired: {
      preTreatmentCiedCheckRequired: 'yes',
      referralToGcCardiologist: 'no',
      otherCiedInstructions: '',
    },
  },
  DoseSiteSummary: {
    enabled: true,
    DateFormat: 'DD/MM/YYYY',
  },
  CardioReferralField: false,
  Tooltips: {
    hasPriority: false,
    hasClinicalPathologicalStaging: true,
  },
  UseDocumentTimezone: true,
  DefaultTimezone: 'Pacific/Auckland',
  DateFormat: 'DD MM YYYY',
  ShortDateFormat: 'DD/MM/YYYY',
  DiagnosisDateFormat: 'DD-MMM-YYYY',
  CareplanVoidDescription: 'Documentation will be voided in your OIS.',
  EmailMaxLength: 40,
  Outage: {
    link: '',
    showBanner: false,
    message: '',
    campaignId: '',
    startDate: '',
    endDate: '',
  },
  Notes: {
    DateTimeFormat: 'DD/MM/YYYY hh:mm A',
  },
  DefaultLocale: 'en-gb',
  SupportEmail: 'support-anz@lumonus.com',
  ShowResetDemoDataMenuLink: false,
  Insights: {
    mockData: false,
    chartDateFormat: 'DD/MM/YYYY',
    Dashboards: {
      careplanAdherence: false,
      techniques: true,
      averageFractions: true,
      totalReferrals: false,
      totalDiagnosis: true,
      totalPlans: false,
      linacs: true,
      simToTreatment: true,
      averageDailyPlans: false,
      totalConsultations: false,
      totalSimulations: true,
      totalTreatments: true,
    },
  },
  PatientCard: {
    appointmentDateFormat: 'ddd, Do MMM YYYY',
    defaultDateFormat: 'DD-MMM-YYYY',
    defaultAlternateDateFormat: 'DD MMM YYYY',
    dateOfBirthFormat: 'Do MMM YYYY',
  },
  AISummary: {
    lastUpdatedDateTimeFormat: 'DD MMM YYYY, h:mm A',
  },
};

export default anz_conf;
